import { commsManager } from "appworks/server/comms-manager";
import { Contract } from "appworks/utils/contracts/contract";
import { FreespinRequestPayload } from "slotworks/model/gameplay/requests/freespin-request-payload";

export function LoadFreespinCommand(): Contract<void> {
    const payload = new FreespinRequestPayload();

    return commsManager.request(payload);
}
